import React from 'react';
import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

interface HeatmapDataPoint {
  x: string | number;
  y: string | number;
  value: number;
}

interface HeatmapChartProps {
  data: HeatmapDataPoint[];
  title?: string;
  xLabel?: string;
  yLabel?: string;
  height?: number;
}

export const HeatmapChart: React.FC<HeatmapChartProps> = ({
  data,
  title,
  xLabel = 'X',
  yLabel = 'Y',
  height = 300,
}) => {
  // Transform data for bar chart visualization
  const maxValue = Math.max(...data.map((d) => d.value), 0);
  const chartData = data.map((point) => ({
    name: point.y ? `${point.x}-${point.y}` : `${point.x}`,
    value: point.value,
    x: point.x,
    y: point.y,
  }));

  const getColor = (value: number) => {
    const intensity = maxValue > 0 ? value / maxValue : 0;
    const hue = 240 - intensity * 120; // Blue to red
    return `hsl(${hue}, 70%, 50%)`;
  };

  return (
    <div style={{ width: '100%', height }}>
      {title && <h3 style={{ marginBottom: '16px' }}>{title}</h3>}
      <ResponsiveContainer width="100%" height="100%">
        <RechartsBarChart data={chartData}>
          <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
          <YAxis />
          <Tooltip
            formatter={(value: any, name: any, props: any) => [
              value,
              `${xLabel}: ${props.payload.x}, ${yLabel}: ${props.payload.y}`,
            ]}
          />
          <Bar dataKey="value">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getColor(entry.value)} />
            ))}
          </Bar>
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
};
